// The Vue build version to load with the `import` command (runtime-only or
// standalone) has been set in webpack.base.conf with an alias.
require('./bootstrap')
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import ElementUI from 'element-ui';
//import 'element-ui/lib/theme-chalk/index.css';
import ZipCodeInput from "./components/Form/ZipCode";
import store from './store';
import vSelect from 'vue-select';
import i18n from './lang/i18n';
import ToggleButton from 'vue-js-toggle-button'
import Toastr from 'vue-toastr';

import formatters from './formatters';
import money from 'v-money'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'

import VeeValidate from 'vee-validate';
import VuejsDialog from "vuejs-dialog";
import IdleVue from 'idle-vue';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import moment from 'moment-timezone'

//import Vuetify from 'vuetify'
//Vue.use(Vuetify)

Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.use(ClientTable, {}, false, 'bootstrap4', 'default');
Vue.use(ServerTable, {}, false, 'bootstrap4', 'default');
Vue.use(Event)
Vue.use(BootstrapVue)
Vue.use(DatePicker)
Vue.use(ElementUI)
Vue.use(ToggleButton)
Vue.use(Toastr, {
  defaultProgressBar: false,
  preventDuplicates: true,
  preventOpenDuplicates: true
});

// check if idle for 1 hours
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime: 3600000
})
Vue.use(VeeValidate, config);
Vue.use(VuejsDialog, {
  html: true,
  loader: true,
  okText: 'Proceed',
  cancelText: 'Cancel',
  animation: 'bounce'
});


Vue.use(money, {
  precision: 2,
  prefix: "$"
});

// Global filter for date
Vue.filter('utcDate', (d, format="lll") => {
  const dDate = moment.utc(d);
  if(dDate.isValid()) return dDate.format(format);
  return "No Date";
})
Vue.filter('readableDate', (d, format="lll") => {
  // console.log('READABLE')
  // console.log('TZ', moment.tz.guess());
  // console.log("RAW Date: ", d)

  const dDate = moment.utc(d).tz(moment.tz.guess());
  // console.log("CONVERTED Date: ", dDate.format())

  if(dDate.isValid()) return dDate.format(format);
  return "No Date";
})
Vue.filter('ago', (d) => {
  const dDate = moment.utc(d).tz(moment.tz.guess());
  if(dDate.isValid()) return dDate.fromNow() ;
  return "No Date";
})
Vue.filter('truncate', function (value, size=45, clamp="...") {
  if (!value) return '';
  value = value.toString();
  if (value.length <= size) return value;
  return value.substr(0, size) + clamp;
});

// Global components
Vue.component('zip-code-input', ZipCodeInput);

// Localization

try {
  window.$ = window.jQuery = require('jquery');
  window.Cookies = require('js-cookie');

  Vue.prototype.numeral = require('numeral');
  Vue.prototype.console = window.console;
  Vue.prototype.format = formatters;
  Vue.prototype.formatters = formatters;
  Vue.prototype._ = _;
} catch (e) {}

require('./components/Table');

const files = require.context('./components', true, /\.vue$/i)
files
  .keys()
  .map(key => {
    Vue.component(key.split('/').pop().split('.')[0], files(key))
  })

// Print
window.Sha256 = require('./vendor/sha-256.min.js');
window.RSVP = require('./vendor/rsvp-3.1.0.min.js');
window.qz = require('./vendor/qz-2.1.2.js');
qz
  .security
  .setCertificatePromise((resolve, reject) => {
    resolve(`-----BEGIN CERTIFICATE-----
    MIIFHTCCAwegAwIBAgIFMTE3NzQwCwYJKoZIhvcNAQEFMIGYMQswCQYDVQQGEwJV
    UzELMAkGA1UECAwCTlkxGzAZBgNVBAoMElFaIEluZHVzdHJpZXMsIExMQzEbMBkG
    A1UECwwSUVogSW5kdXN0cmllcywgTExDMRkwFwYDVQQDDBBxemluZHVzdHJpZXMu
    Y29tMScwJQYJKoZIhvcNAQkBFhhzdXBwb3J0QHF6aW5kdXN0cmllcy5jb20wHhcN
    MjExMDExMDQwMDAwWhcNMjMxMDMxMDQwMDAwWjCB5zELMAkGA1UEBgwCVVMxETAP
    BgNVBAgMCE5ldyBZb3JrMREwDwYDVQQHDAhCcm9va2x5bjEZMBcGA1UECgwQR3Jh
    bmRTaGlwcGVyIEluYzEZMBcGA1UECwwQR3JhbmRTaGlwcGVyIEluYzEZMBcGA1UE
    AwwQR3JhbmRTaGlwcGVyIEluYzEjMCEGCSqGSIb3DQEJAQwUamF5QGdyYW5kc2hp
    cHBlci5jb20xPDA6BgNVBA0MM3JlbmV3YWwtb2YtNTdkYzk2MjgzZDNkNDVhYmM2
    OTY4NGE1MmFlNjJjZmE4ODEzNDc1NjCCASAwCwYJKoZIhvcNAQEBA4IBDwAwggEK
    AoIBAQCSsbFmq913NovH7vO4v3L3AnHw0J+F9nFD7y0ZFt3pNxSoFboZJ+Rf47JL
    IA+gD8GgNbFmwJBqs3walaIsIF8NgE7JNCIir+qpnidZxNjYn2LkrIq83FIe+W/T
    vVfrI62vGwVHTw13PRQ0X31BUACn3wqc1VSS9d60kf5BwSh1paoMjVHehzDeKuPI
    upMHZ5w6v4AP7pjQxz1NI6U5jSbO592apO5ZkA+2PNe71l7rWVDQPEIM47P+Rfnz
    IrlHDFSwgKWF5G/yxXQ7gMUXJc3fNEtaIU31SEkYyBtuejZ1v/80XtBjPQ3MU0fS
    e9iZ40OojlnTUrk2gpVZ+JK41qFPAgMBAAGjIzAhMB8GA1UdIwQYMBaAFJCmULeE
    1LnqX/IFhBN4ReipdVRcMAsGCSqGSIb3DQEBBQOCAgEAh4vMwhh8bX+Qe4OG0QQU
    f3JkeJuNhcusRaBZF8ab9M5AIhBOYu+nrQMl8DN0mRX9m7ImVBjz28kAztlwfd2I
    dzb41OLighJc2fIMM8pWhfE+hTtNZALgaOl1W9nxM5LAkCWEwnqrWAjFBFbj+Qbz
    Rmk0HLrwfbDbFlU6N/tutmA9WNn6Zjhdb4Va0cFlDb2GRTUGYcFfamkZ3jhuJhoH
    Rxvd7UyeHsX9Yoran62HvUiviAtXstWPmcCHUwTx5NLCSMPheiE6r4pVVbwPqkbH
    vC6BhhlpnTvRYgtRuc8GVz1gPCKZ7H927VRVq0Q+10IbXYsy6Zx+gtqAVWwn59VZ
    WTUNrN3dgS5dh5ZbqDleLZyd/1wXoNkQb7z5MXf+8//ZAuGbzsLzYEAg7wFA876+
    pqJfk6YSaHdfV/qWiWg7onqMN554HgpMUzKbVf3pO98ObuQ0Hy+R/F2wuOlJp2Oc
    b6s1gfCMfDlyJREktmeDm7v4MBz3bTdNJObcrv79t7OjzBP1nxFe/B26/uGPYeqh
    S2v3zaJ51Zy9CaSpV8JAlMHSk0IS6XOu2BvKiM6m/z/rPPliJYJGAs0H7r1LLIen
    k6LZTZy5BYItY0N0g+Ywf426zyhxPGMmdMGjZw7T0VJTK4UUOMRtkRwJTyEXM6d/
    ZdKRHoJPRU8/GAQ6aLPpbhs=
    -----END CERTIFICATE-----
    --START INTERMEDIATE CERT--
    -----BEGIN CERTIFICATE-----
    MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
    MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
    bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
    A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
    emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
    gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
    cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
    EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
    c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
    iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
    YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
    GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
    EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
    0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
    xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
    9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
    ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
    2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
    6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
    5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
    plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
    BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
    eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
    gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
    x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
    pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
    2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
    rbO7BnjW
    -----END CERTIFICATE-----`);
  });

qz
  .security
  .setSignaturePromise(function (toSign) {
    return function (resolve, reject) {
      axios
        .get('/print/sign?request=' + toSign)
        .then((response) => {
          resolve(response.data)
        }, reject);
    };
  });

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document
  .head
  .querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const config = {
  events: '',
  classes: true,
  classNames: {
    valid: 'valid',
    invalid: 'is-invalid'
  },
  // Fix for error: The computed property "fields" is already defined as a prop.
  fieldsBagName: 'veeFields'
};

Vue.component('new-integration-shopify', require('./components/NewIntegrationShopify.vue'));
Vue.component('new-integration-ebay', require('./components/NewIntegrationEbay.vue'));
Vue.component('new-integration-amazon', require('./components/NewIntegrationAmazon.vue'));
Vue.component('v-select', vSelect);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {
    App
  },
  onIdle(){
    // console.log('inactive/idle');
    const pattern = new RegExp(/^\/auth\/.*$/, 'i');
    const path = this.$route.path;
    if(!pattern.test(path)){
      axios.post("/logout", {})
        .then(function(response) {
          alert("You have been automatically logged out due to inactivity.");
          // localStorage.clear();
          localStorage.removeItem('shipper');
          window.location = "/";
        });
    }else{ }
  },
  onActive(){
    // console.log('is active');
  }
})

Vue.dialog.registerComponent('pausable', require('./components/Dialogs/Pausable.vue'));
Vue.dialog.registerComponent('warning', require('./components/Dialogs/Warning.vue'));
Vue.dialog.registerComponent('void', require('./components/Dialogs/Void.vue'));
Vue.dialog.registerComponent('print', require('./components/Dialogs/Print.vue'));


// WEBPACK FOOTER //
// ./resources/assets/js/main.js